// Non usare i trattini perchè causano errori
export const PRODUCTS_DESCRIBE: string = 'products';